<template>
    <div class="content">
        <div class="container">
            <h1 class="mb-5">
                Billing
            </h1>


            <div v-if="$route.query.payment=='success'"
                 class="alert bg-white text-success border border-success p-3 mb-5">
                <strong>Thank for payment. ID #{{ $route.query.id }}</strong>
            </div>

            <h5 v-if="is_expire() == false" class="mb-5">
                Your account will expire in {{ expire_date }}.
            </h5>
            <div v-if="is_expire() == -1" class="mb-5 alert alert-warning">
                Please Activate Your Subscription!
            </div>
            <div v-if="is_expire() == true" class="mb-5 alert alert-danger">
                Your Account has expired.
            </div>

            <div class="bg-white d-flex shadow-sm rounded">
                <div class="p-3 flex-fill w-100">
                    <h4>Premium Plan</h4>
                    <small class="text-muted">Everything and More</small>
                </div>
                <div class="p-3 flex-fill">
                    <h4>$50.00</h4>
                    <small class="text-muted">/ per month</small>
                </div>
            </div>

            <button :disabled="disable == 1" class="mt-5 mb-5 btn btn-block btn-success" @click="paynow">
                PAY NOW
            </button>
            <br>
            <ul class="nav nav-tab mb-5">
                <li class="nav-item ml-0 pl-0" :class="{active: tab=='history'}">
                    <a href="#" class="nav-link" @click="tab ='history'">Billing
                        History</a>
                </li>
                <li class="nav-item" :class="{active: tab=='info'}">
                    <a href="#" class="nav-link" @click="tab ='info'">Billing Info
                    </a>
                </li>
            </ul>

            <table v-if="tab=='history'" class="table bg-white border">
                <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>Amount</th>
                    <th>Description</th>
                </tr>
                <tr v-for="item in orders">
                    <td>{{ item.id }}</td>
                    <td>{{ item.updated_at }}</td>
                    <td>${{ item.payment_total }}</td>
                    <td>{{ item.plan_name }}</td>
                </tr>
            </table>
            <card-box v-if="tab=='info'">
                <card-title>Billing information</card-title>
                <billing-info/>
            </card-box>
        </div>
    </div>
</template>

<script>
    import CardBox from "../components/CardBox";
    import BillingInfo from "../components/BillingInfo";
    import CardTitle from "../components/CardTitle";
    import InputEdit from "../components/InputEdit";
    import EditAble from "../components/EditAble";

    export default {
        name: "Pricing",
        components: {EditAble, InputEdit, CardTitle, BillingInfo, CardBox},
        data: function () {
            return {
                tab: 'history',
                disable: 0,
                orders: [],
                settings: []
            }
        },
        computed: {
            expire_date: function () {
                return this.$moment(this.settings.expire_date).format('MMMM Do YYYY');
            }
        },
        mounted() {

            this.$store.commit('ACTIVE_SIDEBAR', 'billing')
            this.list()
            this.setting()

            if (this.$route.query.payment == 'success') {
                this.$author.refreshToken()
            }

        },
        methods: {

            setting: function () {
                let vm = this


                this.$http.get(this.$config.api + 'store/setting').then(function (res) {
                    vm.settings = res.data
                })
            },
            paynow: async function () {
                if (this.disable == 1) return
                this.disable = 1
                await this.$http.get(this.$config.api + 'billing/initcheckout/1').then(function (res) {
                    window.location.href = res.data.url

                })
            },
            list: function () {
                let vm = this
                this.$http.get(this.$config.api + 'billing').then(function (res) {
                    vm.orders = res.data.items
                })
            },
            is_expire: function () {
                console.log(this.settings.expire_date)

                if (this.settings.expire_date == null || this.settings.expire_date == '' || this.settings.expire_date == undefined) return -1

                if (this.$moment() > this.$moment(this.settings.expire_date)) {
                    return true
                }

                return false
            }
        }
    }
</script>

<style scoped lang="scss">

</style>